import { render, staticRenderFns } from "./SettingsBackground.vue?vue&type=template&id=18507d53&"
import script from "./SettingsBackground.vue?vue&type=script&lang=js&"
export * from "./SettingsBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports